import React, { useState } from "react";
import { formatDate } from "../../../utils/utilityfunc";
import { convertThenFormat } from "../../common-data/Converts";
import "../../../styles/centralised-plan/pt-cpplans.css";
import { CheckCircleIcon, CrossCircleIcon } from "../../../images/icons/icons";

const DetailListings = ({ row, isPT }) => {
  const [activeTab, setActiveTab] = useState("individual");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  return (
    <>
      <div className="user-profile-container staff-onboarding-detail-modal">
        <div className="user-profile-details">
          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Date Added</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.date_added
                  ? formatDate(new Date(Number(row.date_added) * 1000))
                  : "-"}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Couple Plan</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.couple_included ? (
                  <CheckCircleIcon />
                ) : (
                  <CrossCircleIcon />
                )}{" "}
                {row?.couple_included ? row?.couple_plan_name : ""}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">All gym access</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.is_allgym_access ? (
                  <CheckCircleIcon />
                ) : (
                  <CrossCircleIcon />
                )}
              </p>
            </div>
          </div>

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Partial Allowed</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">
                {row?.is_partial ? <CheckCircleIcon /> : <CrossCircleIcon />}
              </p>
            </div>
          </div>

          {row?.is_partial ? (
            <>
              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">1st EMI %</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{row?.first_emi_percentage || 0}%</p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">2nd EMI %</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {row?.second_emi_percentage || 0}% (
                    {row?.second_emi_duration || 0} Days)
                  </p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">3rd EMI %</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">
                    {row?.third_emi_percentage || 0}% (
                    {row?.third_emi_duration || 0} Days)
                  </p>
                </div>
              </div>
            </>
          ) : null}

          <div className="user-details">
            <div className="user-details-head">
              <p className="head-name">Partial Allowed In A Month</p>
            </div>
            <div className="user-details-info">
              <p className="info-name">{row?.fd_link_allowed || 0}</p>
            </div>
          </div>

          {/* PT Addon specific details */}
          {isPT && (
            <>
              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">Status</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{row?.status || "NA"}</p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">For</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{row?.addon_for || "NA"}</p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">Intensity</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{row?.intensity || "NA"}</p>
                </div>
              </div>

              <div className="user-details">
                <div className="user-details-head">
                  <p className="head-name">Available Days</p>
                </div>
                <div className="user-details-info">
                  <p className="info-name">{row?.addon_days || "NA"}</p>
                </div>
              </div>

              {row?.description && (
                <div className="user-details">
                  <div className="user-details-head">
                    <p className="head-name">Description</p>
                  </div>
                  <div className="user-details-info">
                    <div
                      className="info-name"
                      dangerouslySetInnerHTML={{
                        __html: row.description,
                      }}
                    ></div>
                  </div>
                </div>
              )}

              {/* Session Details Section */}
              {row?.session_details && row.session_details.length > 0 && (
                <div className="session-details-section">
                  <h3 className="session-details-title">Session Packages</h3>
                  <div className="session-cards">
                    {row.session_details.map((session, index) => (
                      <div className="session-card" key={index}>
                        <div className="session-header">
                          <div className="session-title">
                            Package {index + 1}
                          </div>
                          {session.is_trial ? (
                            <div className="session-badge trial">Trial</div>
                          ) : null}
                        </div>
                        <div className="session-info">
                          <div className="info-item">
                            <span className="info-label">Sessions:</span>
                            <span className="info-value">
                              {session.num_session}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Duration:</span>
                            <span className="info-value">
                              {session.duration} days
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">Base Price:</span>
                            <span className="info-value">
                              ₹{convertThenFormat(session.base_price)}
                            </span>
                          </div>
                          <div className="info-item">
                            <span className="info-label">
                              Final Base Price:
                            </span>
                            <span className="info-value">
                              ₹{convertThenFormat(session.final_base_price)}
                            </span>
                          </div>
                        </div>
                        {session.selling_prices &&
                          session.selling_prices.length > 0 && (
                            <div className="selling-prices">
                              <div className="selling-price-header">
                                Selling Prices
                              </div>
                              <div>
                                {session.selling_prices.map((price, idx) => (
                                  <div className="selling-price-item" key={idx}>
                                    <span className="price-label">
                                      ₹
                                      {convertThenFormat(
                                        price.final_selling_price
                                      )}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}

          {/* Price Details Section */}
          {row?.price_details && row.price_details.length > 0 && (
            <div className="price-details-section">
              <h3 className="price-details-title">Pricing Options</h3>

              <div className="price-tabs">
                <div className="price-tab-headers">
                  <button
                    className={`price-tab-btn ${
                      activeTab === "individual" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("individual")}
                  >
                    Individual Plans
                  </button>
                  <button
                    className={`price-tab-btn ${
                      activeTab === "couple" ? "active" : ""
                    }`}
                    onClick={() => handleTabClick("couple")}
                  >
                    Couple Plans
                  </button>
                </div>

                <div
                  className={`price-tab-content ${
                    activeTab === "individual" ? "active" : ""
                  }`}
                >
                  <div className="price-cards">
                    {row.price_details
                      .filter((price) => Number(price.is_couple) === 0)
                      .map((price) => (
                        <div className="price-card" key={price.id}>
                          <div className="price-amount">
                            ₹{convertThenFormat(price.plan_price || 0)}
                          </div>
                          <div className="price-extend">
                            <span className="extend-badge">
                              {price.extend_days}{" "}
                              {parseInt(price.extend_days) > 1 ? "Days" : "Day"}{" "}
                              Extended
                            </span>
                          </div>
                          {/* <div className="price-coupon">
                            <span className="coupon-code">{price.coupon}</span>
                          </div> */}
                        </div>
                      ))}
                  </div>
                </div>

                <div
                  className={`price-tab-content ${
                    activeTab === "couple" ? "active" : ""
                  }`}
                >
                  <div className="price-cards">
                    {row.price_details
                      .filter((price) => Number(price.is_couple) === 1)
                      .map((price) => (
                        <div className="price-card" key={price.id}>
                          <div className="price-amount">
                            ₹{convertThenFormat(price.plan_price || 0)}
                          </div>
                          <div className="price-extend">
                            <span className="extend-badge">
                              {price.extend_days}{" "}
                              {parseInt(price.extend_days) > 1 ? "Days" : "Day"}{" "}
                              Extended
                            </span>
                          </div>
                          {/* <div className="price-coupon">
                            <span className="coupon-code">{price.coupon}</span>
                          </div> */}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailListings;
